import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { ISaveSelectedOfferRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSaveSelectedOfferThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SaveSelectedOffer,
    async (payload: {
      applicationId: string;
      selectedOffer: ISaveSelectedOfferRequest;
      isPPCJourneyLoanOffer?: boolean;
    }) => {
      const response = await api.saveSelectedOffer(
        payload.applicationId,
        payload.selectedOffer,
        payload.isPPCJourneyLoanOffer,
      );

      return response;
    },
  );
